// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#tblMain[data-v-377d10aa]{\r\n  /*width: 1000px;*/\n}\n.btn-dangerU[data-v-377d10aa]{\r\n  color: white !important;\r\n  margin: 5px;\r\n  width: 40px;\n}\n.btn-primaryU[data-v-377d10aa]{\r\n  color: white !important;\r\n  margin: 5px;\r\n  width: 120px;\n}\r\n", ""]);
// Exports
module.exports = exports;
